<div class="contenedor-boton-volver">
    <button type="button" class="boton-volver" fill="clear" (click)="alHacerClicVolver()">
        <ion-icon [name]="nombreIcono"></ion-icon>
        <span>{{ texto }}</span>
    </button>
</div>